<template>
    <div class="refer-parent w-100 pb4 pt1">
        <div class="shares-container pa3">
            <div class="shares-count light-br-r w-50 fl pr4">
                <p class="share-item share-desc">Your shares</p> 
                <p class="share-item share-count"><strong>{{ sentRefs }}</strong></p>
            </div>
            <div class="shares-count w-50 fr pl4">
                <p class="share-item share-desc">Signed up</p> 
                <p class="share-item share-count"><strong>{{ refCount }}</strong></p>
            </div>
        </div>
        <!-- <div class="referrals-list">
            Shared to:
            <div v-for="referral in referrals">
                {{ referral.new_user }}, signed up: {{ referral.signed_up }}
            </div> 
        </div> -->
    </div>
</template>

<script>
import request from 'request';
import 'lodash';

export default {
    props: {
        user: Object
    },
    data() {
        return {
            referrals: [],
            refCount: 0,
            sentRefs: 0,
            userObj: {
                email: this.user.email,
                uid: this.user.uid
            }
        }
    },
    methods: {
        fetchData() {
            var self = this;

            var options = {
                url: process.env.HOME_API + "/api/referral/" + this.user.uid,
                method: 'GET',
            }

            request(options, function (error, response, body) {
                var json = JSON.parse(body);
                self.referrals = json.referrals;
                json.referrals.map(ref => {
                    if (ref.signed_up == 1) self.refCount++;
                    self.sentRefs++;
                })
            });
        },
    },
    mounted() {
        if (this.user.email !== "" && this.user.uid !== "") {
            this.fetchData();
        }
    },
    watch: {
        user: {
            handler(newUser, oldUser) {
                this.userObj = newUser;
                this.fetchData();
            },
            deep: true
        }
    }
}
</script>



// WEBPACK FOOTER //
// _vue/components/ReferredUsers.vue